import ReactECharts from "echarts-for-react";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { getConfig } from "Components/Report/OnDemand/charts/shared/config";
import { ReportDeviceStatus, ReportAccountStatus } from "Utility/Types/report";
import { setL1Visible, setOnEventValues } from "Components/Report/reportSlice";
import { useReportClick } from "Components/Report/queries";
import { useAppSelector, useAppDispatch } from "store/hook";
import { hoverFormat } from "./shared/utils";
interface T {
  good: number[];
  fair: number[];
  poor: number[];
  // na: number[],
}

const SignalBar = ({
  param,
  id = "",
  data,
  isFetching,
  name,
}: {
  param: Parameter;
  id?: string;
  data?: ReportDeviceStatus[] | ReportAccountStatus[];
  isFetching: boolean;
  name?: string;
}) => {
  const disp = useAppDispatch();
  const { title, Ymax, Yunit, Xaxis, Xunit, isDarkMode } = useChartParam(param, id, data, name);
  const { mutateAsync: getClickMutation } = useReportClick();
  const { level, stateCid, loginCid } = useAppSelector((state) => state.global);
  const { filterForm } = useAppSelector((state) => state.report);
  const seriesData = (data as (ReportDeviceStatus & ReportAccountStatus)[])?.reduce<T>(
    (a, b) => {
      return {
        ...a,
        good: [...a.good, b?.interface?.lte?.[id === "" ? "signal_good_devices" : "signal_good"]],

        fair: [...a.fair, b?.interface?.lte?.[id === "" ? "signal_fair_devices" : "signal_fair"]],

        poor: [...a.poor, b?.interface?.lte?.[id === "" ? "signal_poor_devices" : "signal_poor"]],
        // na: [...a.na, b?.interface?.lte?.[id === "" ? "na_devices" : "na"]],
      };
    },
    {
      good: [],
      fair: [],
      poor: [],
      // na: [],
    }
  );

  const getClickData = (values: any) => {
    if (!data) {
      return;
    }

    const { start_utc, end_utc, unit } = data[values.dataIndex];

    getClickMutation({
      duration: { start_utc, end_utc, unit },
      level,
      stateCid,
      loginCid,
      account_devices: filterForm.account_device,
    }).then((data) => {
      const eventValue = { ...data.response[0], click: values.seriesName.toLowerCase(), type: "signal" };

      disp(setL1Visible(true));
      disp(setOnEventValues(eventValue));
    });
  };

  const config = getConfig({
    isDarkMode,
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        return hoverFormat(params, data);
      },
    },
    xAxis: [
      {
        data: Xaxis,
        name: Xunit,
        axisLabel: {
          color: isDarkMode ? "white" : "gray",
        },
      },
    ],
    yAxis: [
      {
        name: Yunit,
        max:
          Ymax ||
          function (value: any) {
            return value.max + 5;
          },
        axisLabel: {
          color: isDarkMode ? "white" : "gray",
        },
      },
    ],
    series: [
      {
        name: "Poor",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: isDarkMode ? "darkgray" : "#343a40",
        },
        emphasis: {
          focus: "series",
        },
        data: seriesData?.["poor"],
      },

      {
        name: "Fair",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: "#dc3545",
        },
        emphasis: {
          focus: "series",
        },
        data: seriesData?.["fair"],
      },
      {
        name: "Good",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: "#ffc107",
        },
        emphasis: {
          focus: "series",
        },
        data: seriesData?.["good"],
      },
    ],
    legend: {
      textStyle: {
        color: isDarkMode ? "white" : "black", // 新增深色模式時 報表字體顏色為 #white
      },
    },
  });

  const onEvent = (values: any) => {
    if (id !== "") {
      return;
    }
    getClickData(values);
  };

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      <ReactECharts
        // echarts={echarts}
        option={config}
        style={{ height: "100%" }}
        // notMerge={true}
        // lazyUpdate={true}
        // theme={isDarkMode ? "dark" : "default"}
        // onChartReady={this.onChartReadyCallback}
        // onEvents={EventsDict}
        onEvents={{ click: (e: any) => onEvent(e) }}
        // opts={}
      />
    </ChartCard>
  );
};

export default SignalBar;
